import { familyFeaturePreviewFree, familyFeaturePreviewPaid } from 'reactApp/appHelpers/featuresHelpers/features/familyFunctions';
import { getFamilyAlbumsFeature, getFamilyFoldersFeature } from 'reactApp/modules/family/family.selectors';
import { historyPush } from 'reactApp/modules/router/router.module';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';
import { store as reduxStore } from 'reactApp/store';
import { sendXray } from 'reactApp/utils/ga';

import { create } from './create';

export const createFamilyFolder = (from = 'toolbar') => {
    const state = reduxStore.getState();

    const hasFamilyFoldersFeature = getFamilyFoldersFeature(state);
    const hasFamilyAlbumsFeature = getFamilyAlbumsFeature(state);
    const isPaid = UserSelectors.isPaidUser(state);

    const showToFreeUser = familyFeaturePreviewFree && !isPaid;
    const showToPaidUser = familyFeaturePreviewPaid && isPaid;
    sendXray('toolbar_item-click_createFamilyFolder');

    if (!hasFamilyFoldersFeature && !hasFamilyAlbumsFeature && (showToFreeUser || showToPaidUser)) {
        reduxStore.dispatch(historyPush({ id: `/family/folders/` }));
    } else {
        create('familyFolder', from, undefined, '', false, true);
    }
};
